import React from "react";

// Company name component to share across pages
const companyDetails = {
  name: "GoFood LLC ",
};

const CompanyNameHeader = () => {
  return (
    <h1 className="text-2xl font-extrabold text-gray-900 mb-6 leading-snug">
      <span className="text-blue-700">{companyDetails.name}</span>
      <span className="text-gray-700">
  | Business Valuation Report
  <span className="ml-2 inline-flex items-center px-2 py-0.5 text-xs font-semibold text-blue-600 bg-blue-100 rounded-full align-middle" title="Password Protected Report (Premium)">
    PPR*
  </span>
</span>


    </h1>
  );
};

export default CompanyNameHeader;
